/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import type { InstructorProfile } from 'bundles/degree-description/__generated__/baseContentfulTypes';
import LazyImgix from 'bundles/page/components/shared/LazyImgix';

type Props = {
  instructorItem: InstructorProfile;
};

const styles = {
  gridItem: () => css`
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-gap: var(--cds-spacing-200);
  `,
  infoListImage: css`
    border: 2px solid #e5e7e8;
    border-radius: 50%;
    width: 111px;
  `,
  margin: (value: string) => css`
    margin: ${value};
  `,
};

const Instructor = ({ instructorItem }: Props) => {
  const image = instructorItem.profilePicture;

  if (!image?.url || !instructorItem.name || !instructorItem.position) {
    return null;
  }
  return (
    <Grid item xs={12} sm={6} md={4} css={styles.gridItem}>
      {image?.url && image?.width && image?.height && (
        <LazyImgix
          css={styles.infoListImage}
          src={image.url}
          alt={instructorItem.name}
          maxWidth={image.width}
          maxHeight={image.height}
          enableFluidWidth={true}
        />
      )}
      <div>
        <Typography2 component="h3" variant="subtitleMedium" css={styles.margin('0 0 var(--cds-spacing-100)')}>
          {instructorItem.name}
        </Typography2>
        <Typography2 component="p" variant="bodySecondary">
          {instructorItem.position}
        </Typography2>
      </div>
    </Grid>
  );
};

export default Instructor;
